<template>
  <div>
    <select-field label='设备名称' v-model="device" :list="devices" :disabled="!editable"></select-field>
    <select-field label='数据点' v-model="data" :list="datas" :disabled="!editable"></select-field>
    <submit-field @click="submit" :disabled="!editable">确定</submit-field>
  </div>
</template>

<script>
  /**
   * defaults example: {
   *   deviceId: 1,
   *   dataId: 1,
   *   devices: [
   *     {
   *       name: '设备1',
   *       id: 1,
   *       datas: [
   *         {
   *           name: '数据点1',
   *           id: 1
   *         }
   *       ]
   *     }
   *   ]
   * }
   */
  import SelectField from '@/components/utils/select-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    data () {
      return {
        deviceType: '',
        device: {},
        data: {}
      }
    },
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'interface',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    components: {
      SelectField,
      SubmitField
    },
    methods: {
      refresh () {
        let deviceId = this.defaults.deviceId
        let dataId = this.defaults.dataId

        this.setValue(deviceId, dataId)
      },
      setValue (deviceId, dataId) {
        this.device = ''
        this.data = ''

        this.defaults.devices.forEach(device => {
          if (deviceId === device.id) {
            this.device = device

            device.datas.forEach(data => {
              if (dataId === data.id) {
                this.data = data
              }
            })
          }
        })
      },
      submit () {
        this.$emitter.emit(this.event, {
          deviceId: this.device.id,
          dataId: this.data.id
        })

        this.editable = false
      }
    },
    created () {
      this.refresh()
    },
    computed: {
      devices () {
        return this.defaults.devices.map(device => {
          return {
            key: device.name,
            value: device
          }
        })
      },
      datas () {
        return (this.device && this.device.datas) ? this.device.datas.map(data => {
          return {
            key: data.name,
            value: data
          }
        }) : []
      }
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/metadata.vue